<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up clone-deck">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Clone Deck</h3>
            <p class="clone-deck-hint">The new deck gets the same columns, tags, settings and users.</p>

            <label class="clone-deck-label" for="clone-deck-name">Name</label>
            <input id="clone-deck-name" type="text" v-model="name" @keyup.enter="submit()" />

            <label class="clone-deck-check">
                <input type="checkbox" v-model="includeCards" />
                <span>Also clone all cards, with their checklists, comments and files</span>
            </label>

            <input :class="disableButton ? 'disable-button' : ''" type="submit" :value="disableButton ? 'Cloning...' : 'Clone'" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

// Clone Deck (a deck's 3-dot menu; API companyboards.ts POST /clone). slug / deckName: the deck being cloned.
// Opens the new deck once it's made.
export default defineComponent({
    name: 'CloneDeckModal',
    props: {
        slug: { type: String, required: true },
        deckName: { type: String, default: '' }
    },
    emits: [ 'close' ],
    data() {
        return {
            name: 'Copy of ' + this.deckName,
            includeCards: false,
            disableButton: false
        }
    },
    mounted() {
        (document.getElementById('clone-deck-name') as HTMLInputElement | null)?.select();
    },
    methods: {
        async submit() {
            if(this.disableButton) {
                return;
            }
            if(!this.name.trim()) {
                alert('Give the new deck a name.');
                return;
            }
            this.disableButton = true;
            try {
                const resp = await axios.post(`${this.$store.state.apiUrl}/api/companyboards/clone`, { Slug: this.slug, Name: this.name.trim(), IncludeCards: this.includeCards });
                this.$emit('close');
                this.$router.push('/deck/' + resp.data.Slug);
            } catch(e: any) {
                console.log(e);
                alert(e?.response?.data || 'There was an error');
            }
            this.disableButton = false;
        }
    }
});
</script>

<style scoped>
.clone-deck-hint { font-size: 13px; color: var(--font-mid-gray); margin: 0 0 12px; }
.clone-deck-label { display: block; font-weight: 600; margin: 0 0 6px; }
.clone-deck input[type=text] { margin-bottom: 12px; }
.clone-deck-check { display: flex; align-items: center; gap: 10px; margin: 4px 0 14px; cursor: pointer; font-size: 14px; line-height: 1.3; font-weight: normal; }
/* The font sits a little high in its line box, so the text is nudged down to center on the checkbox */
.clone-deck-check span { position: relative; top: 2px; }
.clone-deck-check input[type=checkbox] { width: 16px; height: 16px; margin: 0; padding: 0; flex-shrink: 0; }
</style>
